export const OnScreenKeyboardLayouts = {
  DECIMAL_LAYOUT: ['1 2 3', '4 5 6', '7 8 9', '{clear} 0 .'],

  NON_DECIMAL_WITH_ENTER_BKSP_LAYOUT: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {enter}'],

  NON_DECIMAL_WITH_CLEAR_BKSP_LAYOUT: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {clear}'],

  NON_DECIMAL_WITH_ENTER_CANCEL_BKSP_LAYOUT: ['1 2 3', '4 5 6', '7 8 9', '{bksp} 0 {cancel}', '{enter}'],
  
  NON_DECIMAL_WITH_ENTER_CLEAR_LAYOUT: ['1 2 3', '4 5 6', '7 8 9', '{clear} 0 {enter}'],

  NON_DECIMAL_WITH_ENTER_CANCEL_CLEAR_LAYOUT: ['1 2 3', '4 5 6', '7 8 9', '{clear} 0 {cancel}', '{enter}'],

  NON_DECIMAL_WITH_CLEAR_LAYOUT: ['1 2 3', '4 5 6', '7 8 9', '{clear} 0'],
  
  NON_DECIMAL_WITH_CLEAR_ENTER_SEPARATE_ROW_LAYOUT: ['1 2 3', '4 5 6', '7 8 9', '{clear} 0', '{enter}'],

  DECIMAL_LAYOUT_WITH_ENTER: [
    '1 2 3',
    '4 5 6',
    '7 8 9',
    '{clear} 0 .',
    '{enter}'
  ],

  DECIMAL_LAYOUT_WITH_CLEAR_CANCEL_ENTER: [
    '1 2 3',
    '4 5 6',
    '7 8 9',
    '{clear} 0 .',
    '{cancel} {enter}'
  ],

  DEFAULT_KEYBOARD_LAYOUT_WITHOUT_ENTER: [
    '` 1 2 3 4 5 6 7 8 9 0 - = {bksp}',
    '{tab} q w e r t y u i o p [ ] \\',
    '{lock} a s d f g h j k l ; \'',
    '{shift} z x c v b n m , . / {shift}',
    '.com @ {space}'
  ]
};
